import {MessagingRole} from 'Users/models/User/MessagingUserType';

export class MessageSenderUserType {
  public readonly key = 'MessageSenderUserType';
  public readonly messagingRole = MessagingRole.MessageSender;
}
